// extracted by mini-css-extract-plugin
module.exports = {"modale":"AddGoogleConnectModal_modale__1Zil4","containerButtons":"AddGoogleConnectModal_containerButtons__1HywH"};